const SAFE = /^(https?:|mailto:)/i;

export const isSafeUrl = (v) => {
  if (!v) return false;
  try { return SAFE.test(new URL(String(v).trim()).protocol); } catch { return false; }
};

export const safeUrl = (v) => (isSafeUrl(v) ? String(v).trim() : null);
